"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILAssignmentViewerPopupArgs = exports.ILAssignmentViewerDefaultArgs = exports.AssignmentViewerPopup = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var typeography_common_1 = require("../typeography/typeography.common");
var il_assignment_viewer_1 = require("./il-assignment-viewer");
var ILAssignmentViewerDefaultArgs = {
    courseSubject: enums_1.SubjectEnum.ELECTIVES,
    onLessonContentClick: console.log,
    onQuestionClick: console.log,
    studentName: 'Joey',
    avatar: 'RED',
    dueText: 'Due October 8th',
    children: (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'center' } },
        react_1.default.createElement(typeography_common_1.ILBody2, null, "Lesson content under construction"))),
};
exports.ILAssignmentViewerDefaultArgs = ILAssignmentViewerDefaultArgs;
var ILAssignmentViewerPopupArgs = __assign(__assign({}, ILAssignmentViewerDefaultArgs), { menuComponent: (react_1.default.createElement(material_1.IconButton, { "aria-label": "Menu", sx: {
            cursor: 'pointer',
        } },
        react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.ELLIPSIS, size: enums_1.IconSizeEnum.SMALL }))) });
exports.ILAssignmentViewerPopupArgs = ILAssignmentViewerPopupArgs;
function AssignmentViewerPopup(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.maxWidth, maxWidth = _c === void 0 ? 'md' : _c, _d = _a.fullScreen, fullScreen = _d === void 0 ? false : _d, onFullScreen = _a.onFullScreen, onClose = _a.onClose, menuComponent = _a.menuComponent, dialogProps = _a.dialogProps, props = __rest(_a, ["open", "maxWidth", "fullScreen", "onFullScreen", "onClose", "menuComponent", "dialogProps"]);
    var _e = react_1.default.useState(fullScreen), isFullScreen = _e[0], setFullScreen = _e[1];
    return (react_1.default.createElement(material_1.Dialog, __assign({ onClose: onClose, open: open, maxWidth: maxWidth, fullScreen: isFullScreen, fullWidth: true, PaperProps: { sx: { backgroundColor: 'background.default' } } }, dialogProps),
        react_1.default.createElement(material_1.Box, { sx: { position: 'absolute', pt: '1.5rem', pr: '1.5rem', top: 0, right: 0, zIndex: 1 } },
            react_1.default.createElement(material_1.Box, { sx: { display: 'flex', gap: '0.5rem' } },
                react_1.default.createElement(material_1.IconButton, { onClick: function () {
                        setFullScreen(!isFullScreen);
                        onFullScreen && onFullScreen(!isFullScreen);
                    }, "data-testid": "expand-icon", "aria-label": "Expand modal" }, isFullScreen ? (react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.DOWN_LEFT_AND_UP_RIGHT_TO_CENTER, size: enums_1.IconSizeEnum.SMALL })) : (react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.UP_RIGHT_AND_DOWN_LEFT_FROM_CENTER, size: enums_1.IconSizeEnum.SMALL }))),
                menuComponent,
                react_1.default.createElement(material_1.IconButton, { onClick: onClose, "data-testid": "close-icon", "aria-label": "Close modal" },
                    react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON, size: enums_1.IconSizeEnum.SMALL })))),
        react_1.default.createElement(il_assignment_viewer_1.ILAssignmentViewer, __assign({}, props))));
}
exports.AssignmentViewerPopup = AssignmentViewerPopup;
